import { browserInfo } from '../../utils';

const info = browserInfo();

const contextDefaultValues = {
  browser: info,
};

export default contextDefaultValues;
